import {ENDPOINTS} from '~/constants';
import {FetchParams, PostParams, PutParams, DeleteParams} from 'redux-thunk-kit';

import {QuestionnaireEntity, NormalizedQuestionnaire} from '~/types/models/questionnaire';
import {questionnaireSchema} from '~/redux/questionnaires/entity-config';
import {thunk} from '~/utils/thunk';

export interface FetchQuestionnairesParams extends FetchParams {
  methodKey: string;
}

export interface FetchMdqStatusParams extends FetchParams {
  id: string;
}

export interface AddQuestionnaireParams extends PostParams {
  data: Partial<QuestionnaireEntity>;
}

export interface SubmitOrLogMdqParams extends PostParams {
  data: {
    uid?: string | null;
    methodKey: string;
    status: 'draft' | 'submitted';
    data: any;
  };
}

export interface UpdateQuestionnaireParams extends PutParams {
  data: Partial<QuestionnaireEntity>;
  id: number;
}

const query = thunk.query<QuestionnaireEntity, NormalizedQuestionnaire>('questionnaire', questionnaireSchema, {
  isSnakeCase: false,
});

export const fetchQuestionnaires = query.fetchOne<FetchQuestionnairesParams>(ENDPOINTS.QUESTIONNAIRES, '', {
  withoutNormalize: true,
});

export const addQuestionnaire = query.post<AddQuestionnaireParams>(ENDPOINTS.QUESTIONNAIRES);
export const updateQuestionnaire = query.put<UpdateQuestionnaireParams>(`${ENDPOINTS.QUESTIONNAIRES}/:id`);
export const deleteQuestionnaire = query.delete<DeleteParams>(`${ENDPOINTS.QUESTIONNAIRES}/:id`);

export const submitOrLogMdq = query.post<SubmitOrLogMdqParams, any>(`${ENDPOINTS.MEDICAL_FORMS}`, 'submitOrLog', {
  withoutNormalize: true,
  fixedData: {
    version: 1,
  },
});

export const getMdqStatus = query.fetchOne<FetchMdqStatusParams>(
  `${ENDPOINTS.MEDICAL_FORMS}/:id/status`,
  'getMdqStatus',
  {
    withoutNormalize: true,
  },
);
